import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Unassigns Vehicle Groups from a Routing Profile
 * @param driverGroupId The ID of the Routing Profile who the Vehicle Groups are being unassigned from
 * @param unassignIds The IDs of the Vehicle Groups who are being unassigned
 */
export function postRoutingProfileVehicleGroupsUnassign(
  this: unknown,
  routingProfileId: number,
  unassignIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .routingProfileVehicleGroupsUnassignUrl(routingProfileId),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            vehicleGroupIds: unassignIds,
          }),
        }
      )
    )
  ).pipe(ignoreData());
}
